import { Market } from "../../contracts";

export const isMarketQA = (market: Market): boolean => {
    return market.id ? market.id.indexOf("_") < 0 : false;
}